import { Activity } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString() : "—");
const STATUS_COLOR = { ok: "text-emerald-700", running: "text-blue-700", partial: "text-amber-700", error: "text-red-700", skipped: "text-amber-700", idle: "text-slate-600" };

const Row = ({ label, children, testid }) => (
  <div className="flex items-start justify-between gap-3 py-1.5 border-b border-slate-100 last:border-0 text-sm" data-testid={testid}>
    <span className="text-slate-500 text-xs pt-0.5">{label}</span><span className="text-right text-slate-900 font-medium break-all">{children}</span>
  </div>
);

export const StatusCard = ({ status }) => {
  if (!status) return null;
  const s = status.status || "idle";
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="backup-status-card">
      <h2 className="text-base font-semibold text-slate-900 flex items-center gap-2 mb-2"><Activity className="h-4 w-4 text-slate-500" />Status</h2>
      <Row label="Connected provider" testid="status-provider">{status.provider_label} <span className={`text-xs ${status.live ? "text-emerald-700" : "text-amber-700"}`}>({status.provider_status?.status?.replace(/_/g, " ")})</span></Row>
      <Row label="Destination" testid="status-destination"><span className="font-mono text-xs">{status.destination_display}</span></Row>
      <Row label="Last successful backup" testid="status-last-success">{fmt(status.last_successful_backup) === "—" ? "never" : fmt(status.last_successful_backup)}</Row>
      <Row label="Next scheduled backup" testid="status-next-run">{status.auto_enabled ? fmt(status.next_run_at) : "automatic backup off"}</Row>
      <Row label="Files synchronized" testid="status-files-synced">{status.files_synced} <span className="text-xs text-slate-500">/ {status.documents_total} documents ({status.documents_pending} pending)</span></Row>
      <Row label="Backup status" testid="status-backup-status"><span className={`capitalize ${STATUS_COLOR[s] || ""}`}>{s}</span></Row>
      <div className="mt-3" data-testid="status-errors">
        <div className="text-xs text-slate-500 mb-1">Errors requiring attention</div>
        {(!status.errors || status.errors.length === 0) ? <p className="text-xs text-slate-400">None</p> : (
          <ul className="space-y-1">{status.errors.map((e, i) => <li key={i} className="text-xs text-red-700 bg-red-50 border border-red-100 rounded px-2 py-1 break-all">{e.file ? <span className="font-mono">{e.file}: </span> : null}{e.error}</li>)}</ul>
        )}
        {!status.live && (!status.errors || status.errors.length === 0) && <p className="text-xs text-amber-700 mt-2">{status.provider_status?.message}</p>}
      </div>
    </div>
  );
};
